import React from "react";
import { getLightComponent } from "./utils";
import { SceneLightProps } from "./types";

/**
 * Agreement here that there will be a lookup map that maps the lightType string
 * In Contentful to R3F light components and provide the props!
 * 
 * @example
enum Light {
    Spotlight =  "Spot Light",
    Directional = "Directional Light",
}
const Lights = {
    [Light.Spotlight]: <spotLight />
}
 */

const NVSLight: React.FC<SceneLightProps> = ({
  transform3D,
  hexColor,
  intensity,
  decay,
  distance,
  lightType,
}) => {
  const LightComponent = getLightComponent(lightType);

  return LightComponent ? (
    <LightComponent
      color={hexColor}
      intensity={intensity}
      decay={decay}
      distance={distance}
      position={transform3D?.position}
      rotation={transform3D?.rotation}
      scale={transform3D?.scale}
    />
  ) : null;
};

export default NVSLight;
